/**
 * The one UUID check, for both sides (MAR-948, conventions A3; guard `tests/unit/uuidRegexGuard.test.ts`).
 *
 * The question every caller asks is "will Postgres' `uuid` type accept this string, or answer
 * `22P02 invalid input syntax`?" — on the server so a route param that cannot be an id comes back
 * 404 instead of 500, on the client so an id that cannot exist is never sent. Postgres accepts any
 * version and either case, so this checks the FORMAT: 8-4-4-4-12 hex digits, anchored, any case, no
 * version or variant nibble (a v7 or nil id is an id).
 */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** The same pattern, unanchored — for pulling an id OUT of text such as `cite:section/<uuid>`. */
const UUID_IN_TEXT_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i

export function isUuid(value: unknown): value is string {
  return typeof value === 'string' && UUID_RE.test(value)
}

/** The first UUID inside `text`, lowercased, or `null` when there is none. */
export function findUuid(text: unknown): string | null {
  if (typeof text !== 'string') return null
  const match = text.match(UUID_IN_TEXT_RE)
  return match ? match[0].toLowerCase() : null
}
